<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <h1 style="font-weight: normal">Flow Builder</h1>
      </v-flex>
    </v-layout>
    <v-layout class="mt-2">
      <v-flex md4>
        <v-autocomplete
                v-model="selectedBlock"
                :items="blocksList"
                item-text="name"
                item-value="id"
                @change="updateSelectedBlock"
                solo
                label="Search Blocks"
                prepend-inner-icon="search"
                :return-object="true"
        >
        </v-autocomplete>
        <groups></groups>
      </v-flex>
      <v-flex md8 class="pl-5">
        <blocks :blocks-list="blocksList"></blocks>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import groups from '../components/block-build/groups/groups'
  import blocks from '../components/block-build/blocks/blocks'
  import common from "../utils/common";
  export default {
    components: {
      groups,
      blocks
    },
    data () {
      return {
        bots: [],
        blocksList: [],
        selectedBlock: {},
        selectedOnce: false,
      }
    },
    mounted() {
      this.getBlocksList()
      this.getVariables()
      this.getSettings()
    },
    methods: {
      getBlocksList() {
        this.$http_bot.get('/blocks')
                .then(response=>{
                  this.blocksList = response.data
                  if(this.$route.query.block) {
                    this.updateSelectedQueryBlock()
                  }
                })
                .catch(error=>{
                  if (error.response.status === 401) {
                    common.logOut()
                  }
                })
      },
      getSettings() {
        this.$http_bot.get('/settings/')
          .then(response=>{
            this.settings = response.data
            if (!this.settings.nlp) {
              this.settings.nlp = {}
            }
            this.$store.dispatch('setSettings',this.settings)
          })
          .catch(error=>{
            if (error.response.status === 401) {
              common.logOut()
            }
          })
      },
      getVariables() {
        this.$http_bot.get('/blocks/variables/available')
                .then(response=>{
                  const variables = []
                  for (let i = 0; i<response.data.length; i++) {
                    if (response.data[i].variable !== '') {
                      variables.push(response.data[i])
                    }
                  }
                  variables.push('channel')
                  this.$store.dispatch('setVariables', variables)
                })
                .catch(error=>{
                  if (error.response.status === 401) {
                    common.logOut()
                  }
                })
      },
      updateSelectedBlock() {
        if(this.selectedBlock && this.selectedBlock.id)
        this.$store.dispatch('setSelectedBlock',this.selectedBlock).then(()=>{
          this.selectedOnce = true
        })
      },
      updateSelectedQueryBlock() {
        setTimeout(()=>{
          const filtered = this.blocksList.filter(i => i.id == this.$route.query.block)
          if(filtered && filtered.length) {
            // console.log('update')
            this.selectedBlock = filtered[0]
            this.$store.dispatch('setSelectedBlock',this.selectedBlock)
          } // console.log('refused')
        }, 200)
      }
    },
    computed: {
      selectedBlockState() {
        return this.$store.state.blocksBuild.selectedBlock
      },
      newBlock() {
        return this.$store.state.blocksBuild.newBlock
      },
      deletedBlock() {
        return this.$store.state.blocksBuild.deletedBlock
      },
      editedBlock() {
        return this.$store.state.blocksBuild.updatedBlockName.name
      }
    },
    watch: {
      selectedBlockState (state) {
        if ( state.id !== this.selectedBlock.id ) {
          this.selectedBlock = {}
        }
      },
      newBlock(state) {
        if (state) {
          this.getBlocksList()
        }
      },
      editedBlock(state) {
        if (state) {
          this.getBlocksList()
        }
      },
      deletedBlock(state) {
        if (state) {
          this.getBlocksList()
        }
      }
    }
  }
</script>
